export default __webpack_public_path__ + "static/5_21-b59304666464f50ac89adf072c3b3b1e.png";